import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { CFormSelect } from '@coreui/react-pro'

const RoleSelector = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const profile = useSelector((state) => state.profile)
  const selectedRole = useSelector((state) => state.selectedRole)

  useEffect(() => {
    // Carrega a role do localStorage ao montar o componente
    const storedRole = localStorage.getItem('selectedRole')
    if (profile && profile.roles && storedRole && profile.roles.includes(storedRole)) {
      dispatch({ type: 'set', selectedRole: storedRole })
    } else if (profile && profile.roles && profile.roles.length > 0) {
      // Define a primeira role se não houver role salva
      dispatch({ type: 'set', selectedRole: profile.roles[0] })
    }
  }, [dispatch, profile])

  const handleChange = (e) => {
    const newRole = e.target.value
    dispatch({ type: 'set', selectedRole: newRole })
    localStorage.setItem('selectedRole', newRole) // Salva a role no localStorage
  }

  if (!profile || !profile.roles || profile.roles.length <= 1) {
    return null // Não mostra o seletor se não houver roles ou apenas uma
  }

  return (
    <div style={{ padding: '10px' }}>
      <CFormSelect value={selectedRole || ''} onChange={handleChange}>
        {profile.roles.map((role) => (
          <option key={role} value={role}>
            {t(role)}
          </option>
        ))}
      </CFormSelect>
    </div>
  )
}

export default RoleSelector
